<script setup lang="ts">
import type { TeamMemberForAvatar } from "@asap/shared/utils/supabase.types";
import { getFullName } from "@asap/shared/utils/people";

withDefaults(defineProps<{ teamMember?: TeamMemberForAvatar; showName?: boolean }>(), {
  showName: true,
  teamMember: undefined,
});

const ui = {
  cell: "flex items-center gap-1",
  avatarWrapper: "h-full",
};
</script>

<template>
  <div v-if="teamMember" :class="ui.cell">
    <div :class="ui.avatarWrapper">
      <TeamMemberAwAvatar :team-member="teamMember" size="xs" :has-tooltip="!showName" />
    </div>
    <TextEllipsis v-if="showName">
      {{ getFullName(teamMember) }}
    </TextEllipsis>
  </div>
  <div v-else>-</div>
</template>
